/* ADD GROUPS */
export const LIST_REPORT3 = "LIST_REPORT3"
export const LIST_REPORT3_SUCCESS = "LIST_REPORT3_SUCCESS"
export const LIST_REPORT3_CLEAN = "LIST_REPORT3_CLEAN"
export const LIST_REPORT3_ERROR = "LIST_REPORT3_ERROR"
